<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <!-- Label -->
    <span *ngIf="label" class="label">{{ label }}</span>
    <lf-help-tooltip *ngIf="helpMessage" [help]="helpMessage"></lf-help-tooltip>

    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending()"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="relativeStorage.shouldShowRejected()"
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Input group -->
    <div
      class="input-group input-group-sm"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Code -->
      <div *ngIf="code" class="input-group-prepend">
        <div class="input-group-text">{{ code }}</div>
      </div>

      <!-- Textarea -->
      <textarea
        #focusTarget
        type="text"
        class="form-control"
        [class.is-warning]="relativeStorage.shouldShowWarning()"
        [class.is-invalid]="relativeStorage.shouldShowError()"
        [class.is-readonly]="isReadOnly"
        [style.height]="initialHeight"
        [name]="path"
        [value]="relativeStorage.get()"
        [attr.minLength]="minLength"
        [attr.maxLength]="maxLength"
        [readonly]="isReadOnly"
        autocomplete="off"
        (input)="_onInput($event)"
        (focus)="_onFocus($event)"
        (blur)="_onBlur($event)"
      ></textarea>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
